
import { collection, getDocs, limit, orderBy, query, where } from 'firebase/firestore';
import { db } from '../firebase';
import { getCache, setCache, clearCacheByPrefix } from '../utils/cache';

const TTL = 5 * 60 * 1000;

function normalize(docSnap) {
  const data = docSnap.data() || {};

  const total = Number(data.grandTotal || data.total || 0);
  const paid = Number(data.paidAmount || 0);
  const dueDate = data.dueDate || "";

  const today = new Date().toISOString().slice(0,10);

  let status = "unpaid";

  if (paid >= total && total > 0) {
    status = "paid";
  } 
  else if (paid > 0 && paid < total) {
    status = "partial";
  } 
  else if (dueDate && dueDate < today) {
    status = "overdue";
  }

  return {
    id: docSnap.id,
    invoiceNumber: data.invoiceNumber || data.number || "",
    clientName: data.clientName || data.companyName || "",
    dueDate,
    status,
    outstanding: Math.max(0, total - paid),
  };
}

export async function getOverdueSummary({ force = false, maxItems = 6 } = {}) {
  const cacheKey = `bauheld:overdue:summary:${maxItems}`;
  if (!force) {
    const cached = getCache(cacheKey, TTL);
    if (cached) return cached;
  }

  const today = new Date().toISOString().slice(0, 10);

  const q = query(
    collection(db, 'invoices'),
    where('paidAmount', '<', 999999999),
    where('dueDate', '<', today),
    orderBy('dueDate', 'asc'),
    limit(maxItems)
  );

  const snap = await getDocs(q);
  const rows = snap.docs
  .map(normalize)
  .filter((row) => row.status === "overdue");
  const payload = {
    count: rows.length,
    totalOutstanding: rows.reduce((sum, row) => sum + Number(row.outstanding || 0), 0),
    rows,
    checkedAt: new Date().toISOString(),
  };

  setCache(cacheKey, payload);
  return payload;
}

export function clearOverdueSummaryCache() {
  clearCacheByPrefix('bauheld:overdue:summary:');
}
